// TODO: This file is copy pasted from web/src/utils/matchesAction.ts
export default function matchesAction(action: { type: string }, type: string): boolean {
  if (!action.type) {
    throw new Error(`Invalid action with no type: ${action}`);
  } else if (typeof type !== "string") {
    throw new Error(`Invalid type: ${type}`);
  }
  return action.type === type;
}
